import { render, staticRenderFns } from "./bs.vue?vue&type=template&id=fd6ef564&scoped=true&"
import script from "./bs.vue?vue&type=script&lang=js&"
export * from "./bs.vue?vue&type=script&lang=js&"
import style0 from "./bs.vue?vue&type=style&index=0&id=fd6ef564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6ef564",
  null
  
)

export default component.exports